import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List, ListItemButton, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import { CommentAlertOutline } from 'mdi-material-ui';
const SectionsMenu = ({ menuItems, onMenuItemChange, value, data, }) => {
    const [selectedIndex, setSelectedIndex] = useState(menuItems.findIndex((item) => item.key === value));
    return (_jsx(List, Object.assign({ component: "nav", sx: { bgcolor: '#F5F4FC', minWidth: '194px', minHeight: '180px' } }, { children: menuItems.map((menu, index) => (_jsx(Tooltip, Object.assign({ title: menu === null || menu === void 0 ? void 0 : menu.tooltip, placement: "right", arrow: true }, { children: _jsxs(ListItemButton, Object.assign({ selected: selectedIndex === index, onClick: (event) => {
                    setSelectedIndex(index);
                    onMenuItemChange(menu.key);
                } }, { children: [_jsx(Typography, Object.assign({ variant: "h5", fontWeight: selectedIndex === index ? 600 : 400 }, { children: menu.displayName })), data[menu.key]['comment'] !== '' && (_jsx(CommentAlertOutline, { sx: {
                            width: '12px',
                            height: '12px',
                            marginLeft: '4px',
                        } }))] }), index) })))) })));
};
export default SectionsMenu;
